export const basicLinkedinLink = {
  firstConnection: "F",
  secondConnection: "S",
  thirdConnection: "O",
}
